export default "__VITE_ASSET__bHtsEsIb__"